import axios from 'axios';

const API_URL = 'https://server.oasissgr.in/api'
export default axios.create({
    baseURL: API_URL,
});

export const getDetailsById = async (module, id, cb) => {
    const { data } = await axios.get(`${API_URL}/${module}/${id}`);
    cb(data);
}

export const downloadFile = async (fileId) => {
    return `https://drive.google.com/uc?export=download&id=${fileId}`;
}
